module.exports = __webpack_public_path__ + "images/emoji/ng.12a8f9e115e7e341aba8.png";